"use strict";
/**
 * QMS message preprocessing (Android M0.w + ForPDA removeSelectionBBCodes).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripQmsHighlighting = stripQmsHighlighting;
exports.preprocessQmsMessage = preprocessQmsMessage;
const HIGHLIGHT_PREFIXES = [
    '[backgroud=yellow][color=red]',
    '[background=yellow][color=red]',
    '[backgroud=darkred][color=white]',
    '[background=darkred][color=white]',
];
const HIGHLIGHT_SUFFIXES = [
    '[/color][/background]',
    '[/color][/backgroud]',
];
const MARKER_START = '\u0002';
const MARKER_END = '\u0003';
/** Android P0.h0 wrapper length before \u0002 when using default yellow/red highlight. */
const ANDROID_HIGHLIGHT_PREFIX_LEN = 29;
/** Chars after \u0003: `[/color][/background]` */
const ANDROID_HIGHLIGHT_SUFFIX_LEN = 22;
function findHighlightPrefixStart(text, markerStart) {
    for (const prefix of HIGHLIGHT_PREFIXES) {
        const pos = text.lastIndexOf(prefix, markerStart);
        if (pos >= 0 && pos + prefix.length === markerStart) {
            return pos;
        }
    }
    if (markerStart >= ANDROID_HIGHLIGHT_PREFIX_LEN) {
        return markerStart - ANDROID_HIGHLIGHT_PREFIX_LEN;
    }
    return Math.max(0, markerStart);
}
function findHighlightSuffixEnd(text, markerEnd) {
    for (const suffix of HIGHLIGHT_SUFFIXES) {
        if (text.startsWith(suffix, markerEnd + 1)) {
            return markerEnd + 1 + suffix.length;
        }
    }
    if (text.startsWith('[/color][/backgrou', markerEnd + 1)) {
        const close = text.indexOf(']', markerEnd + 1);
        if (close > markerEnd) {
            return close + 1;
        }
    }
    return Math.min(text.length, markerEnd + 1 + ANDROID_HIGHLIGHT_SUFFIX_LEN);
}
/**
 * Remove search-highlight markers and BB wrappers from QMS text.
 * Mirrors stripping (not coloring) of Android highlight markers + ForPDA `removeSelectionBBCodes`.
 */
function stripQmsHighlighting(text) {
    if (!text)
        return '';
    let result = text;
    for (;;) {
        const start = result.indexOf(MARKER_START);
        if (start < 0)
            break;
        const end = result.indexOf(MARKER_END, start + 1);
        if (end < 0) {
            result = result.replace(/\u0002/g, '').replace(/\u0003/g, '');
            break;
        }
        const beforeStart = findHighlightPrefixStart(result, start);
        const afterEnd = findHighlightSuffixEnd(result, end);
        const inner = result.slice(start + 1, end);
        result = result.slice(0, beforeStart) + inner + result.slice(afterEnd);
    }
    for (const prefix of HIGHLIGHT_PREFIXES) {
        result = result.split(prefix).join('');
    }
    for (const suffix of HIGHLIGHT_SUFFIXES) {
        result = result.split(suffix).join('');
    }
    return result;
}
/**
 * Подготовка текста QMS перед BBCode-парсером.
 */
function preprocessQmsMessage(text, options) {
    let s = stripQmsHighlighting(text || '');
    if (options?.hasAttachments && !/\[NA(?:=\d+)?\]/i.test(s)) {
        s = s.length > 0 ? `${s}\n[NA]` : '[NA]';
    }
    return s;
}
